import React from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space } from "antd";

const Map = () => {
  return (
    <div className="video-url-container">
      <Form.List name="videos">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Space
                key={key}
                style={{ display: "flex", marginBottom: 8 }}
                align="baseline"
              >
                <Form.Item
                  {...restField}
                  name={[name, "title"]}
                  label="Title"
                  rules={[{ required: false, message: "Missing Title" }]}
                >
                  <Input placeholder="" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, "url"]}
                  label="Virtual Tour Video URL"
                  rules={[{ required: false, message: "Missing url" }]}
                >
                  <Input placeholder="YouTube, Vimeo, SWF File and MOV File are supported" />
                </Form.Item>
                <MinusCircleOutlined onClick={() => remove(name)} />
              </Space>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Add field
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </div>
  );
};

export default Map;
